<app-header></app-header>
<div class="wrapper" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="150"
  [infiniteScrollDisabled]="shimarStatus">
  <div class="mt-4">
    <section class="related-search upcoming" *ngIf="!shimarStatus && reletedShows?.length > 0">
      <div class="container">
        <div class="section-head col-12">
          <h2>{{ "VIDEO_DETAIL.RELATED_VIDEOS" | translate }}</h2>
        </div>
        <div class="row custome-set">
          <div class="series-box" *ngFor="let show of reletedShows">
            <app-grid [data]="show" [gridType]="'landscape'"></app-grid>
          </div>
        </div>
        <div class="record-not-available" *ngIf="reletedShows?.length == 0">
          <div class="text-center">
            <img src="assets/images/no-recoard-playlist.png" />
            <p class="no-recored-content text-secondary">
              {{ "RECORD_NOT_FOUND" | translate }}
            </p>
          </div>
        </div>
      </div>

      <div *ngIf="loadMore" class="w-100">
        <article class="related-search sim-gallery">
          <div class="container">
            <div class="row custome-set mb-3">
              <div class="series-box">
                <div class="simmer-animation series-img"></div>
                <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
              </div>
              <div class="series-box">
                <div class="simmer-animation series-img"></div>
                <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
              </div>
              <div class="series-box">
                <div class="simmer-animation series-img"></div>
                <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
              </div>
              <div class="series-box">
                <div class="simmer-animation series-img"></div>
                <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
              </div>
              <div class="series-box">
                <div class="simmer-animation series-img"></div>
                <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
    <section *ngIf="reletedShows?.length === 0 && !shimarStatus">
      <div class="record-not-available">
        <div class="text-center">
          <img src="assets/images/no-recoard-playlist.png" />
          <p class="no-recored-content text-secondary">
            {{ "RECORD_NOT_FOUND" | translate }}
          </p>
        </div>
      </div>
    </section>
    <app-grid-simmer class="search-page list-simmer" *ngIf="shimarStatus"></app-grid-simmer>
  </div>
</div>
<app-footer></app-footer>